import { z } from 'zod';

export const RecipeSchema = z.object({
  id: z.string().min(1, 'id is required'),
  name: z.string().min(1, 'name is required'),
  chapter: z.string().min(1, 'chapter is required'),
  emoji: z.string().min(1, 'emoji is required'),
  // Optional photo path — if present, the card shows the image instead of
  // the emoji fallback. Must start with '/' so it resolves from public/.
  photo: z.string().regex(/^\//, 'photo path must start with /').optional(),
  description: z.string().min(1, 'description is required'),
  tags: z.array(z.string()).min(1, 'at least one tag'),
});

export type Recipe = z.infer<typeof RecipeSchema>;
export const RecipesSchema = z.array(RecipeSchema);
